import { useState, useRef, useEffect } from 'react'
import api from '../services/api'

interface PlanoConta {
  placod: number
  plades: string
}

interface Props {
  empcod: number | null
  value: string
  onChange: (cod: string, des: string) => void
}

export default function PlanoContasSelect({ empcod, value, onChange }: Props) {
  const [aberta, setAberta] = useState(false)
  const [filtro, setFiltro] = useState('')
  const [planos, setPlanos] = useState<PlanoConta[]>([])
  const [localCod, setLocalCod] = useState(value)
  const [aviso, setAviso] = useState('')
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => { setLocalCod(value); if (value) setAviso('') }, [value])

  useEffect(() => {
    api.get('/erp/planos', { params: empcod ? { empcod } : {} }).then(r => setPlanos(r.data)).catch(() => setPlanos([]))
  }, [empcod])

  useEffect(() => {
    function handler(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setAberta(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const selecionado = planos.find(p => String(p.placod) === value)

  const lista = planos.filter(p => {
    if (!filtro) return true
    const f = filtro.toLowerCase()
    return String(p.placod).includes(f) || p.plades.toLowerCase().includes(f)
  })

  function selecionar(p: PlanoConta) {
    onChange(String(p.placod), p.plades)
    setLocalCod(String(p.placod))
    setAviso('')
    setAberta(false)
    setFiltro('')
  }

  function handleCodBlur() {
    if (!localCod) { onChange('', ''); setAviso(''); return }
    const encontrado = planos.find(p => String(p.placod) === localCod)
    if (encontrado) {
      onChange(localCod, encontrado.plades)
      setAviso('')
      setAberta(false)
    } else {
      onChange('', '')
      setAviso(`Código "${localCod}" não encontrado`)
    }
  }

  return (
    <div className="nat-wrap" ref={ref}>
      <div className="nat-input-row">
        <input
          className="nat-cod-input"
          type="text"
          placeholder="Cód."
          value={localCod}
          style={aviso ? { borderColor: '#dc2626' } : undefined}
          onChange={e => { setLocalCod(e.target.value.replace(/\D/g, '')); setAviso('') }}
          onBlur={handleCodBlur}
          onKeyDown={e => { if (e.key === 'Enter') handleCodBlur() }}
        />
        <div className="nat-desc-box" onClick={() => setAberta(o => !o)}>
          {selecionado
            ? <span className="nat-dsc">{selecionado.plades}</span>
            : <span className="nat-placeholder">Selecione ou digite o código...</span>
          }
          <span className="nat-chevron">{aberta ? '▴' : '▾'}</span>
        </div>
      </div>
      {aviso && <div style={{ fontSize: '0.75rem', color: '#dc2626', marginTop: '0.2rem', paddingLeft: '0.25rem' }}>{aviso}</div>}

      {aberta && (
        <div className="nat-lista">
          <div className="nat-filtro-wrap">
            <input
              autoFocus
              className="nat-filtro"
              placeholder="Buscar por código ou descrição..."
              value={filtro}
              onChange={e => setFiltro(e.target.value)}
            />
          </div>
          <div className="nat-itens">
            {lista.length === 0 && <div className="nat-vazio">Nenhum resultado</div>}
            {lista.map(p => (
              <button
                key={p.placod}
                className={`nat-item${String(p.placod) === value ? ' nat-item--ativo' : ''}`}
                onClick={() => selecionar(p)}
              >
                <div className="nat-item-linha1">
                  <span className="nat-item-cod">#{p.placod}</span>
                </div>
                <div className="nat-item-dsc">{p.plades}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
